/* eslint-disable react/destructuring-assignment */
import React, { useContext } from "react";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import moment from "moment";
import CustomData from "pages/_components/CustomData/CustomData";
import { bool } from "prop-types";

const TransmitCedipShortSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { creationDateTime = moment(), idTransaction = "" } = transaction;
    return (
        <>
            <div className="ticket__body ticket__full-width echeq-emit">
                <div className="echeq">
                    <div className="data-personal">
                        <CustomData
                            titleText="transaction.process.details.table.header.transaction"
                            titleTextType="I18N"
                            valueText={idTransaction.substring(0, 8).toUpperCase()}
                            isDesktop={props.isDesktop}
                        />
                        <CustomData
                            titleText="echecks.createdRange.label"
                            titleTextType="I18N"
                            valueText={creationDateTime}
                            valueTextType="DATE"
                            isDesktop={props.isDesktop}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

TransmitCedipShortSummaryBody.propTypes = {
    isDesktop: bool,
};

TransmitCedipShortSummaryBody.defaultProps = {
    isDesktop: false,
};

export default TransmitCedipShortSummaryBody;
